<template>
  <div>
    <div class="d-flex justify-center">
      <v-slide-group
        show-arrows
        mandatory
        active-class="boton-color-talana"
        v-model="selected"
        class="mb-6"
      >
        <v-slide-item
          v-for="n in templatesOptions"
          :key="n.value"
          v-slot="{ active, toggle }"
        >
          <v-tooltip
            max-width="200"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mx-2 letter-spacing-0"
                :input-value="active"
                active-class="boton-color-talana white--text"
                depressed
                rounded
                @click="toggle"
              >
                {{ n.value }}
              </v-btn>
            </template>
            <span>{{ tabTooltip[n.value] }}</span>
          </v-tooltip>
        </v-slide-item>
      </v-slide-group>
    </div>
    <kv-assignment-template
      v-if="selected === 0 && kvTemplates"
      :kv-templates="kvTemplates"
      :category="1"
      :company="company"
      @update="getTemplates"
    />
    <kv-pending-template
      v-if="selected === 1 && kvTemplates"
      :kv-templates="kvTemplates"
      :category="2"
      :company="company"
      @update="getTemplates"
    />
    <kv-expiration-template
      v-if="selected === 2 && kvTemplates"
      :kv-templates="kvTemplates"
      :category="3"
      :company="company"
      @update="getTemplates"
    />
    <kv-answered-template
      v-if="selected === 3 && kvTemplates"
      :kv-templates="kvTemplates"
      :category="4"
      :company="company"
      @update="getTemplates"
    />
  </div>
</template>

<script>
import KvAssignmentTemplate from './components/kv-assignment-template.vue';
import KvExpirationTemplate from './components/kv-expiration-template.vue';
import KvPendingTemplate from './components/kv-pending-template.vue';
import KvAnsweredTemplate from './components/kv-answered-template.vue';
import { getKvEmailTemplates } from '../../../../api/keyvitae/email-templates';

export default {
  components: {
    KvAssignmentTemplate,
    KvExpirationTemplate,
    KvPendingTemplate,
    KvAnsweredTemplate,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      templatesOptions: [
        { value: 'Asignación' },
        { value: 'Recordatorio' },
        { value: 'Expiración' },
        { value: 'Rendido' },
      ],
      selected: null,
      kvTemplates: null,
      tabTooltip: {
        'Asignación': `Se enviará a tus postulantes para informarles que tienen una nueva
          solicitud por realizar dentro de tu proceso`,
        'Recordatorio': `Funciona a modo de recordatorio, para postulantes que tengan una solicitud
          pendiente aún no realizada.`,
        'Expiración': `Transcurridos los días de vigencia que elegiste, este correo informa que la
          solicitud pendiente ya no puede ser realizada.`,
        'Rendido': 'Tras la realización de la solucitud, el postulante será informado que la recibiste.',
      },
    };
  },
  methods: {
    getTemplates() {
      getKvEmailTemplates()
        .then((res) => {
          this.kvTemplates = res.emailTemplates;
        });
    },
  },
  beforeMount() {
    this.getTemplates();
  },
};
</script>

<style>

</style>
